import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tooltip, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { colors, pxtorem, RightContainerStyled } from "../../assets/styles/theme";
import OriginalGrid from "./shared/OriginalDataGrid";

import JSZip from "jszip";
import { saveAs } from "file-saver";

import {
  useGetFiles,
  useDeleteClientFile,
  useChangeFileStatus,
  useGetExperiments,
  useUpdateDownloadStatus,
} from "../hooks";

import { useState, useEffect } from "react";
import {
  getUserRoles,
  FILE_LIST_SCREEN_LABEL,
  FILE_LIST_TABLE_PLACEHOLDER,
  FILE_LIST_TABLE_STORAGE_KEY,
} from "../helpers/constants";
import DeleteFile from "./modals/DeleteFile";
import DownloadFile from "./modals/DownloadFile";

import SnackbarComponent from "./shared/SnackBarComponent";
import SnackbarSuccessComponent from "./shared/SnackBarSuccessComponent";
import styled from "styled-components";

export const FileListTableWrapper = styled("div")`
 
  .MuiTableRow-root {
    th.MuiTableCell-root{
      &:nth-child(6) {
        position: sticky;
        right: inherit;
      }
    }
    .MuiTableCell-root{
      &:nth-child(6) {
        position: inherit;
      }
      &:last-child {
        &:after {
          content: '';
          height: 1px;
          background: white;
          border-bottom:solid 1px rgba(0, 0, 0, 0.12);
          position: absolute;
          left: 0; 
          right: 0;
          top: -1px;
        }
          
      }
    }
  }
  .MuiTableHead-root .MuiTableCell-head:last-child,
  .MuiTableRow-root .MuiTableCell-root:last-child {
    max-width: ${pxtorem(110)};
  }
`;

interface FileListComponentProps {}

interface TruncatedTextProps {
  text: string;
  maxLength: number;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ text, maxLength }) => {
  const [truncated, setTruncated] = useState<any>(text);

  useEffect(() => {
    setTruncated(
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text
    );
  }, [text, maxLength]);

  return (
    <Tooltip arrow title={text}>
      {truncated}
    </Tooltip>
  );
};

export const FileListDataColumns = [
  {
    clientName: "Sample Client",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Kiran",
    fileTitle: <TruncatedText text="Test.pdf" maxLength={30} />,
    fileClassified: "sensitive",
    action: null,
    id: 1,
    deleteFlag: false,
  },
  {
    clientName: "Advanced Client",
    category: "Research & Experiments",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Naveen",
    fileTitle: <TruncatedText text="sample.pdf" maxLength={30} />,
    fileClassified: "sensitive",
    action: null,
    id: 2,
    deleteFlag: false,
  },
  {
    clientName: "Test Client",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Geetha",
    fileTitle: <TruncatedText text="Testing.pdf" maxLength={30} />,
    fileClassified: "sensitive",
    action: null,
    id: 3,
    deleteFlag: false,
  },
  {
    clientName: "No Client",
    category: "Research & Experiments",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Rakesh",
    fileTitle: <TruncatedText text="Testing.pdf" maxLength={30} />,
    fileClassified: "non-sensitive",
    action: null,
    id: 4,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 2",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Kiran naik",
    fileTitle: <TruncatedText text="Testing.pdf" maxLength={30} />,
    fileClassified: "non-sensitive",
    action: null,
    id: 5,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 3",
    category: "Research & Experiments",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Kiran Kumar",
    fileTitle: (
      <TruncatedText
        text="Testingfilemorethanthirtycharacterfile.pdf"
        maxLength={30}
      />
    ),
    fileClassified: "sensitive",
    action: null,
    id: 6,
    deleteFlag: false,
  },
  {
    clientName: "Sample Test",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "King",
    fileTitle: <TruncatedText text="Rich.pdf" maxLength={30} />,
    fileClassified: "sensitive",
    action: null,
    id: 7,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 4",
    category: "Research & Experiments",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Naik",
    fileTitle: <TruncatedText text="Testing.pdf" maxLength={30} />,
    fileClassified: "non-sensitive",
    action: null,
    id: 8,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 5",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Kiran Kumar",
    fileTitle: <TruncatedText text="Testing.pdf" maxLength={30} />,
    fileClassified: "sensitive",
    action: null,
    id: 9,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 7",
    category: "Research & Experiments",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Raj",
    fileTitle: (
      <TruncatedText
        text="Testingfilenamehadlargefilenamethaswhyitsellipsestoreducethespacehorizontally.pdf"
        maxLength={30}
      />
    ),
    fileClassified: "non-sensitive",
    action: null,
    id: 10,
    deleteFlag: false,
  },
  {
    clientName: "Sample Client 8",
    category: "File Upload",
    createdDate: "2025-01-28T15:47:34.9433333",
    uploadedBy: "Khan",
    fileTitle: <TruncatedText text="testingFile.pdf" maxLength={30} />,
    fileClassified: "non-sensitive",
    action: null,
    id: 11,
    deleteFlag: false,
  },
];

export const getFileListColumns = () => {
  return [
    {
      value: "clientName",
      label: "Client",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: true,
    },
    {
      value: "uploadType",
      label: "Category",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: true,
    },
    {
      value: "createdBy",
      label: "Uploaded/Submitted By",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: true,
    },
    {
      value: "systemCreatedDateTime",
      label: "Date",
      numeric: false,
      date: true,
      showFilter: true,
      showColumn: true,
    },
    {
      value: "filePath",
      label: "Files/Attachments",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: false,
    },
    {
      value: "fileName",
      label: "File/Research Title",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: true,
    },
    {
      value: "isSensitive",
      label: "File Classification",
      numeric: false,
      date: false,
      showFilter: true,
      showColumn: true,
    },

    {
      value: "action",
      label: "Action",
      numeric: false,
      date: false,
      showFilter: false,
      showColumn: true,
    },
  ];
};

export const FileListColumns = [
  {
    value: "clientName",
    label: "Client",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: getUserRoles().includes("Administrator") ? true : false,
  },
  {
    value: "categoryName",
    label: "Category",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "createdBy",
    label: "Uploaded/Submitted By",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "systemCreatedDateTime",
    label: "Date/Time",
    numeric: false,
    date: true,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "filePath",
    label: "Files/Attachments",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: false,
  },
  {
    value: "fileName",
    label: "Files/Attachments",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "isSensitive",
    label: "File Classification",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },

  {
    value: "action",
    label: "Action",
    numeric: false,
    date: false,
    showFilter: false,
    showColumn: true,
  },
];

const FileListComponent: React.FC<FileListComponentProps> = ({}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");

  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);

  const [selectedFileForActions, setSelectedFileForActions] =
    React.useState<any>({});
  const [actionType, setActionType] = React.useState("");
  const [fileStatus, setFileStatus] = React.useState(false);

  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);

  console.log("selectedFileForActions", selectedFileForActions);

  const [isEditMode, setIsEditMode] = React.useState(false);

  console.log("isEditMode", isEditMode);

  const [clientId, setClientId] = React.useState(null);
  const [fileUploadType, setFileUploadType] = React.useState("");

  const {
    data: getFilesData,
    isLoading: isGetFilesDataPending,
    error: getFilesError,
  } = useGetFiles();

  const {
    data: getExperimentsData,
    isPending: isGetExperimentsDataPending,
    error: getExperimentsError,
    refetch,
  } = useGetExperiments(clientId);

  const { mutate: deleteClientFile, isPending: isDeleteClientFilePending } =
    useDeleteClientFile();

  const { mutate: changeFileStatus, isPending: isChangeFileStatusPending } =
    useChangeFileStatus();

  const {
    mutate: updateFileDownloadStatus,
    isPending: isUpdateFileDownloadStatusPending,
  } = useUpdateDownloadStatus();

  React.useEffect(() => {
    let error: any = getFilesError;
    if (getFilesError && error?.data) {
      setError(true);
      setErrorMessage(error?.data?.message);
    }
  }, [getFilesError]);

  const handelAction = (item: any, type: any, status: any) => {
    console.log("item", item, type, status);

    if (type === "Download") {
      setSelectedFileForActions(item);
      if (item.uploadTypeId === 1) {
        downloadFiles(item.filePath, item);
      } else {
        setOpenDownloadModal(true);
      }
    } else if (type === "Delete" || type === "Status") {
      setSelectedFileForActions(item);
      setOpenDeleteModal(true);
      setActionType(type);
      setFileStatus(status);
    } else if (type === "Status") {
      setSelectedFileForActions(item);
      setOpenDeleteModal(true);
      setActionType("PlatformStatus");
      setFileStatus(status);
    } else if (type === "Edit") {
      setActionType(type);
      setFileStatus(status);
      setFileUploadType("research");

      setSelectedFileForActions({});
      setIsEditMode(false);

      setClientId(item?.experimentId);

      setTimeout(() => {
        console.log("Explicitly refetching for:", item?.experimentId);
        refetch().then((response) => {
          if (response.data?.data?.length > 0) {
            console.log("Fetched fresh data:", response?.data?.data[0]);
            setSelectedFileForActions(response?.data?.data[0]);
            setIsEditMode(true);
          }
        });
      }, 0);
    } else {
      setActionType(type);
      setFileStatus(status);
    }
  };

  React.useEffect(() => {
    if (
      getExperimentsData?.data?.length > 0 &&
      actionType === "Edit" &&
      !isEditMode &&
      Object.keys(selectedFileForActions).length === 0
    ) {
      setSelectedFileForActions(getExperimentsData?.data[0]);
      setIsEditMode(true);
    }
  }, [getExperimentsData, actionType, isEditMode, selectedFileForActions]);

  const redirectManagePlatform = (item: any) => {
 
  };

  const handleFilePopUpClose = () => {
    setClientId(null);
    setSelectedFileForActions({});
    setIsEditMode(false);
  };

  async function downloadFiles(filePaths: any, item: any) {
    // If only one file is provided, download it directly
    if (filePaths.length === 1) {
      const filePath = filePaths[0];
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${filePath}`);
        }
        const blob = await response.blob();
        const filename = filePath.split("/").pop().split("?")[0];
        saveAs(blob, filename); // Download the single file
        console.log(`Downloaded file: ${filename}`);

        updateDownloadStatus(item, [item.id]);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    }
    // If multiple files are provided, bundle them into a zip
    else if (filePaths.length > 1) {
      const zip = new JSZip();

      // Fetch each file and add it to the zip
      const fetchPromises = filePaths.map(async (filePath: any) => {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${filePath}`);
        }
        const blob = await response.blob();
        const filename = filePath.split("/").pop().split("?")[0];
        zip.file(filename, blob);
      });

      try {
        // Wait for all files to be fetched and added to the zip
        await Promise.all(fetchPromises);

        // Generate the zip file
        const content = await zip.generateAsync({ type: "blob" });

        saveAs(content, "download.zip");

        console.log("All files have been downloaded and zipped.");
      } catch (error) {
        console.error("Error downloading files:", error);
      }
    } else {
      console.error("No file paths provided.");
    }
  }

  const handleSaveFormSubmission = () => {
    setIsEditMode(false);
    setSelectedFileForActions({});
    setClientId(null);
  };

  const handelAction12 = async (item: any, type: any, status: any) => {
    console.log("item", item, type, status);

    setActionType(type);
    setFileStatus(status);

    if (type === "Download") {
      setSelectedFileForActions(item);
      if (item.uploadTypeId === 1) {
        downloadFiles(item.filePath, item);
      } else {
        setOpenDownloadModal(true);
      }
    } else if (type === "Delete" || type === "Status") {
      setSelectedFileForActions(item);
      setOpenDeleteModal(true);
    } else if (type === "Edit") {
      // Set file upload type first
      setFileUploadType("research");

      // Check if we're already editing this item
      if (clientId && clientId === item?.experimentId) {
        // We're already editing this item, use existing data
        if (getExperimentsData?.data?.[0]) {
          setSelectedFileForActions(getExperimentsData.data[0]);
          setIsEditMode(true);
        }
      } else {
        // New item to edit - set clientId and wait for data to load
        setClientId(item?.experimentId);
        // Don't set edit mode yet - wait for the API response
      }
    }
  };

  const handleDeleteFileCancel = () => {
    setOpenDeleteModal(false);
    setSelectedFileForActions({});
    setActionType("");
    setFileStatus(false);
    setIsEditMode(false);
  };

  const handleDeleteFileConfirm = () => {
    console.log("selectedFileForActions", selectedFileForActions);
    if (actionType == "Delete") {
      let url =
        (selectedFileForActions?.uploadTypeId == 1 &&
          selectedFileForActions?.uploadType) == "File Upload"
          ? "files"
          : "experiments";

      const body = {
        id:
          (selectedFileForActions?.uploadTypeId == 1 &&
            selectedFileForActions?.uploadType) == "File Upload"
            ? selectedFileForActions?.id
            : selectedFileForActions?.experimentId,
        baseurl: url,
      };
      deleteClientFile(body, {
        onSuccess: onDeleteClientFileSuccess,
        onError: onDeleteClientFileError,
      });
    } else if (actionType == "Status") {
      let reqBody = {
        isSensitive: fileStatus,
      };
      const body = {
        id: selectedFileForActions?.id,
        reqBody: reqBody,
      };
      changeFileStatus(body, {
        onSuccess: onDeleteClientFileSuccess,
        onError: onDeleteClientFileError,
      });
    }
  };

  const onDeleteClientFileSuccess = (response: any) => {
    console.log("success", response);
    const status = fileStatus ? "Sensitive" : "Non-Sensitive";
    const deletedSuccessMessage = `${selectedFileForActions.fileName} has been successfully deleted.`;
    const statusChangeSuccessMessage = `${selectedFileForActions.fileName} has been changed to ${status}`;
    const message =
      actionType == "Delete"
        ? deletedSuccessMessage
        : statusChangeSuccessMessage;

    setOpenDeleteModal(false);
    setSuccess(true);
    console.log("message", message);
    setSuccessMessage(message);
    setSelectedFileForActions({});
    setActionType("");
    setFileStatus(false);
    queryClient.invalidateQueries({ queryKey: ["files"] });
  };

  const onDeleteClientFileError = (error: any) => {
    console.log("error", error);
    setOpenDeleteModal(false);
    setSelectedFileForActions({});
    setActionType("");
    setFileStatus(false);
    setError(true);
    setErrorMessage(error?.data?.message);
  };

  const handleDownloadFileCancel = () => {
    console.log("files");
    setOpenDownloadModal(false);
  };

  const updateDownloadStatus = (selectedFileForActions: any, ids: any) => {
    let reqBody = {
      uploadType: selectedFileForActions?.uploadTypeId,
      files: ids,
    };
    const body = {
      id: selectedFileForActions?.clientId,
      reqBody: reqBody,
    };
    updateFileDownloadStatus(body, {
      onSuccess: onUpdateFileDownloadStatusSuccess,
      onError: onUpdateFileDownloadStatusError,
    });
  };

  const onUpdateFileDownloadStatusSuccess = (res: any) => {
    setOpenDownloadModal(false);
  };

  const onUpdateFileDownloadStatusError = (err: any) => {
    setOpenDownloadModal(false);
  };

  const handleDownloadFileConfirm = (ids: any) => {
    console.log("ids", ids);
    updateDownloadStatus(selectedFileForActions, ids);
  };

  const hideError = () => {
    setError(false);
    setErrorMessage("");
  };

  const hideSuccess = () => {
    setSuccess(false);
    setSuccessMessage("");
  };

  const fileListObject = (filePaths: any) => {
    const fileList = filePaths.map((filePath: any, index: any) => {
      const filename = filePath.filePath.split("/").pop().split("?")[0];
      return {
        id: filePath.fileId,
        name: filename,
        filePath: filePath.filePath,
      };
    });
    return fileList;
  };

  return (
    <RightContainerStyled>
      <Typography variant="h1" component="h1" className="">
        {FILE_LIST_SCREEN_LABEL}
      </Typography>

      <FileListTableWrapper>
        <OriginalGrid
          showUnassignedToggle={false}
          data={getFilesData?.data}
          columns={getFileListColumns()}
          onRowClick={(item) => console.log(item)}
          isGroupingEnabled={false}
          isExportEnabled={false}
          defaultSortColumn="systemCreatedDateTime"
          defaultSortDirection="desc"
          rowsPerPageOptions={[10, 20, 50, 100]}
          storageKey={FILE_LIST_TABLE_STORAGE_KEY}
          loading={isGetFilesDataPending}
          showFileUploadModal={true}
          placeholder={FILE_LIST_TABLE_PLACEHOLDER}
          isFixedColumn={true}
          exportFileName={"FileList"}
          isFixedRightColumn={false}
          handelAction={handelAction}
          isEditMode={isEditMode}
          uploadType={fileUploadType}
          editData={selectedFileForActions}
          handleFilePopUpClose={handleFilePopUpClose}
          handleAttachmentsDownload={() =>
            console.log("handleAttachmentsDownload")
          }
          fromScreen="File-List"
          industryOptions={[]}
          handleSaveFormSubmission={handleSaveFormSubmission}
        />
      </FileListTableWrapper>
      {openDeleteModal && (
        <DeleteFile
          open={openDeleteModal}
          handleCancel={handleDeleteFileCancel}
          handleConfirm={handleDeleteFileConfirm}
          subject={actionType}
          status={fileStatus}
          fileName={selectedFileForActions?.fileName}
          isLoading={isDeleteClientFilePending || isChangeFileStatusPending}
        />
      )}
      {openDownloadModal && (
        <DownloadFile
          open={openDownloadModal}
          handleCancel={handleDownloadFileCancel}
          handleConfirm={handleDownloadFileConfirm}
          fileList={fileListObject(selectedFileForActions?.fileDetailsList)}
        />
      )}
      {error && (
        <SnackbarComponent
          error={error}
          errorMessage={errorMessage}
          hideError={hideError}
        />
      )}
      {success && (
        <SnackbarSuccessComponent
          success={success}
          successMessage={successMessage}
          hideSuccess={hideSuccess}
        />
      )}
    </RightContainerStyled>
  );
};

export default FileListComponent;
